import { useEffect, useState } from "react";
import TopicItem from "../forum/TopicItem";
import ReportReason from "./ReportReason";
import {
  createUUID,
  nightModeStyle,
} from "../../publicFunctions/publicHelpers/helpers";
import Reply from "../forum/Reply";
import { IonIcon } from "@ionic/react";
import { checkmarkDoneOutline, scanOutline } from "ionicons/icons";
import { ackReport, deleteTopic } from "../../publicFunctions/forumHandler";
import DeleteAThing from "../forum/DeleteAThing";
import Comment from "../story/Comment";

function Report({ nightMode, reportObject, searchParams, setSearchParams }) {
  const [renderedReport, setRenderedReport] = useState(null);
  const [mostRecentReason, setMostRecentReason] = useState(null);
  const [loadOtherReasons, setLoadOtherReasons] = useState(false);
  const [otherReasons, setOtherReasons] = useState(null);
  const [ack, setAck] = useState(reportObject?.acknowledged ? true : false);
  const [deleted, setDeleted] = useState(reportObject?.deleted ? true : false);

  useEffect(() => {
    if (reportObject?.type && !renderedReport) {
      const type = reportObject.type;
      let tempReport = null;
      let reportTitle = "";
      if (type === "forumTopic") {
        reportTitle = "ENTIRE THREAD";
        // Note: this one is a special case because the delete icon is not built in
        tempReport = (
          <div className="flex flex--direction-column align-items--end flex--gap-large">
            <TopicItem
              nightMode={nightMode}
              topic={reportObject}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              mutedUsers={{}}
            />
            <DeleteAThing
              nightMode={nightMode}
              rulesType={"forum"}
              isMyThing={false}
              isModerator={true}
              description={"discussion"}
              handleDelete={(reason) => {
                deleteTopic(
                  reportObject.topicId,
                  reportObject.topicTitle,
                  reason ? reason : ""
                ).then(async () => {
                  await handleSetAck(true, reportObject.objectId);
                  setDeleted(true);
                });
              }}
            />
          </div>
        );
      } else if (type === "forumMessage") {
        reportTitle = "FORUM MESSAGE";
        tempReport = (
          <Reply
            isModerator={true}
            canEdit={false}
            publicUserId={reportObject.userId}
            reply={reportObject}
            nightMode={nightMode}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            mutedUsers={{}}
            handleReplyToMessage={() => {}}
            modOnlySetAck={async () => {
              await handleSetAck(true, reportObject.objectId);
              setDeleted(true);
            }}
          />
        );
      } else if (type === "uploadedStoryComment" || type === "replyComment") {
        if (type === "uploadedStoryComment") {
          reportTitle = "STORY COMMENT";
        } else {
          reportTitle = "REPLY FROM AUTHOR***";
        }
        tempReport = (
          <Comment
            myProfile={{ isModerator: true }}
            comment={reportObject}
            publicUserId={reportObject.userId}
            uploadedStory={{}}
            storyId={reportObject.uploadedStoryId}
            canEdit={false}
            thisIsMyStory={false}
            myUserId={""}
            forceRefresh={async () => {
              await handleSetAck(true, reportObject.objectId);
              setDeleted(true);
            }}
            nightMode={nightMode}
            mutedUsers={{}}
          />
        );
      }

      if (tempReport) {
        setRenderedReport(
          <div>
            <p className="description--larger bold">{reportTitle}</p>
            {tempReport}
          </div>
        );
      }
      if (reportObject.acknowledged) {
        setAck(true);
      } else {
        setAck(false);
      }
    }

    if (reportObject?.reportMessages?.length) {
      const tempRecentReportMessage = reportObject.reportMessages[0];
      setMostRecentReason(
        <ReportReason
          nightMode={nightMode}
          reportMessage={tempRecentReportMessage}
        />
      );
    }
  }, [reportObject]);

  useEffect(() => {
    if (
      loadOtherReasons &&
      reportObject?.reportMessages?.length &&
      reportObject.reportMessages.length > 1
    ) {
      const tempOtherReasonList = [];
      for (let i = 1; i < reportObject.reportMessages.length; i++) {
        const tempMessage = reportObject.reportMessages[i];
        tempOtherReasonList.push(
          <ReportReason
            key={reportObject.objectId + "_" + createUUID()}
            nightMode={nightMode}
            reportMessage={tempMessage}
          />
        );
      }
      setOtherReasons(tempOtherReasonList);
    }
  }, [loadOtherReasons, reportObject]);

  const handleSetAck = async (tempAck, objId) => {
    await ackReport(objId, tempAck);
    setAck(tempAck);
  };

  if (!renderedReport || !reportObject) {
    return null;
  }
  return (
    <div className="padding-top-bot--md">
      {deleted ? (
        <p className="description--larger center-text">DELETED</p>
      ) : (
        renderedReport
      )}
      <div className={nightMode ? nightModeStyle : "blue-background"}>
        <div className="flex flex--direction-column align-items--end flex--gap-normal margin--sm">
          <p className="description bold underline">
            {(reportObject?.reportMessages?.length &&
            reportObject.reportMessages.length > 1
              ? "REASONS"
              : "REASON") + " FOR REPORT"}
          </p>
          {mostRecentReason}
          {!loadOtherReasons &&
          reportObject?.reportMessages?.length &&
          reportObject.reportMessages.length > 1 ? (
            <button
              className="cursor--pointer"
              onClick={() => {
                setLoadOtherReasons(true);
              }}
            >
              Load Other Reasons
            </button>
          ) : loadOtherReasons && otherReasons ? (
            <div className="flex flex--direction-column">{otherReasons}</div>
          ) : null}
          {!ack ? (
            <div
              onClick={async (event) => {
                event.preventDefault();
                await handleSetAck(true, reportObject.objectId);
              }}
              className="flex align-items--center justify-content--center cursor--pointer flex--gap-smaller yellow-background"
            >
              <IonIcon className="social-icon" icon={scanOutline} />
              <p className="description bold underline">Acknowledge Report?</p>
            </div>
          ) : (
            <div className="flex flex--direction-column align-items--center justify-content--center">
              <IonIcon
                style={{ color: "green" }}
                className="social-icon--large"
                icon={checkmarkDoneOutline}
              />
              {!deleted ? (
                <p
                  onClick={async (event) => {
                    event.preventDefault();
                    await handleSetAck(false, reportObject.objectId);
                  }}
                  className="description--small underline cursor--pointer"
                >
                  Undo?
                </p>
              ) : null}
            </div>
          )}
        </div>
      </div>

      <div className="simple-divider yellow-background"></div>
    </div>
  );
}

export default Report;
